import type { MailboxInfo } from 'owa-client-types';
import type { OutlookCloudPolicySettingId } from '../store/schema/OutlookCloudPolicyTypes';
import { isPoliciesEnabledForAccount } from '../utils/isPoliciesEnabledForAccount';
import { getPolicyDataBySettingId } from './getPolicyDataBySettingId';

/**
 * Returns the boolean OCPS policy value, or undefined when the account has no value for the
 * requested policy. Use this when absence must preserve an existing behavior instead of falling
 * back to enabled or disabled.
 */
export function getOptionalOcpsPolicyEnabled(
    settingId: OutlookCloudPolicySettingId,
    mailboxInfo: MailboxInfo
): boolean | undefined {
    if (!isPoliciesEnabledForAccount(mailboxInfo)) {
        return undefined;
    }

    const policyValue = getPolicyDataBySettingId(mailboxInfo, settingId)?.value;
    if (policyValue === undefined) {
        return undefined;
    }

    return policyValue === '1';
}
